export default __webpack_public_path__ + "static/media/e-sip-dpo-logo-b.6af33a94.png";